import { useEffect, useState, useCallback } from "react";
import apiClient from "../api/client";

export const useTicketSubStatuses = (domain) => {
  const [subStatuses, setSubStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchSubStatuses = useCallback(async () => {
    if (!domain) {
      setSubStatuses([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await apiClient.get(`/api/ticketsubstatuses?domain=${encodeURIComponent(domain)}`);
      setSubStatuses(res.data || []);
    } catch (err) {
      console.error("Failed to load ticket sub-statuses:", err);
      setError(err.message || "Failed to load sub-statuses");
      setSubStatuses([]);
    } finally {
      setLoading(false);
    }
  }, [domain]);

  useEffect(() => {
    fetchSubStatuses();
  }, [fetchSubStatuses]);

  return { subStatuses, loading, error };
};